<template lang="pug">
  .page
    section
      b-container
        h1 CONGRATULATIONS
        h4 You are now the owner of this piece
        p Your rental payments will be cancelled at the end of the current term
        b-button.btn-outline(:to="{name: 'AccountOrders'}") VIEW ORDER
</template>

<script>

export default {
  name: 'KeepOkay',
  components: {
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/views/KeepOkay.vue